import React from 'react';

const NotFound404 = (props) => {

    return(
        <React.Fragment>
            <div className='pageContent'>
                <h2>The page you are looking for could not be found.</h2>
            </div>
        </React.Fragment>
    );
}

export default NotFound404;